(() => {
  'use strict';
  const STORAGE_KEY = 'mbf_wishlist_v1';
  const buttons = [...document.querySelectorAll('[data-mbf-wishlist]')];
  if (!buttons.length) return;

  const read = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (_) {
      return [];
    }
  };

  const write = (items) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (_) {}
  };

  let saved = read();
  const sync = () => {
    buttons.forEach((button) => {
      const handle = button.dataset.productHandle || '';
      const active = !!handle && saved.includes(handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const handle = button.dataset.productHandle || '';
      if (!handle) return;
      if (saved.includes(handle)) saved = saved.filter((item) => item !== handle);
      else saved = [...saved, handle];
      write(saved);
      sync();
      document.dispatchEvent(new CustomEvent('mbf:wishlist-change', { detail: { items: saved.slice() } }));
    });
  });

  sync();
})();
